import _ from "lodash";
import { useCallback, useState } from "react";
import useSWR from "swr";

/**
 * we need the prices of the delivery services in a lot of places
 * with this hook we can get them when we need them without passing
 * around ton of props
 */

const useDeliveryPrices = () => {
  const { data: prices } = useSWR(`/delivery/prices`, null, {
    revalidateOnFocus: false,
  });

  const getExtraPack = useCallback(
    (type) => {
      if (!prices) return null;

      const extra = prices[type.toLowerCase()].extra[0];

      return {
        pricing_eur: extra.pricing_eur,
        reseller_tier: extra.special_tiers?.find((t) => t.name === "Reseller"),
        id: extra.id,
        quantificable: extra.quantificable,
        unit_pricing_eur: extra.unit_pricing_eur,
      };
    },
    [prices]
  );

  return { prices, getExtraPack };
};

export default useDeliveryPrices;
